const claimTypes = {
	THEFT: "THEFT",
	FIRE: "FIRE",
	STORM: "STORM",
	ESCAPE_OF_WATER: "ESCAPE_OF_WATER",
	IMPACT: "IMPACT",
	MALICIOUS_DAMAGE: "MALICIOUS_DAMAGE",
	PERSONAL_ACCIDENT: "PERSONAL_ACCIDENT",
	SUBSIDENCE: "SUBSIDENCE",
};

export default claimTypes;
